import React from 'react'
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Grid, TextField } from '@material-ui/core'

import { BasePhoneInput } from 'components'

import helpers from 'helpers'

const MainForm = ({ formMethods, verifyDocument }) => {
  const { control, errors } = formMethods

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Controller
          as={
            <TextField
              fullWidth
              error={!!errors.name}
              helperText={errors?.name?.message}
              label="Nome"
              required
            />
          }
          control={control}
          name="name"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Controller
          as={
            <TextField
              fullWidth
              inputProps={{
                maxLength: 18,
              }}
              error={!!errors.cpf}
              helperText={errors?.cpf?.types?.type?.notMatch}
              label="CPF"
              required
            />
          }
          onChange={([event]) => {
            verifyDocument(event.target.value)
            return helpers.formatters.cpf(event.target.value)
          }}
          control={control}
          name="cpf"
          mode="onBlur"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          as={
            <TextField
              fullWidth
              error={!!errors.email}
              helperText={errors?.email?.message}
              label="E-mail de cobrança"
              required
            />
          }
          control={control}
          name="email"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Controller
          as={
            <BasePhoneInput
              label="Telefone"
              error={!!errors.phone}
              helperText={errors?.phone?.message}
              required
              fullWidth
            />
          }
          control={control}
          name="phone"
          mode="onChange"
        />
      </Grid>
    </Grid>
  )
}

MainForm.prototype = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
}

export default MainForm
